import { createRoot } from "react-dom/client";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

import TopNotification from "../components/TopNotification";

export function showNotification(
  message: string,
  icon?: IconDefinition,
  buttonText?: string,
  gotoLink?: string
) {
  const root = document.createElement("div");
  document.body.appendChild(root);

  const reactRoot = createRoot(root);
  setTimeout(() => {
    reactRoot.render(
      <TopNotification
        message={message}
        icon={icon}
        buttonText={buttonText}
        gotoLink={gotoLink}
      />
    );
  }, 2000);

  setTimeout(() => {
    reactRoot.unmount();
    root.remove();
  }, 7000);
}
